import React from 'react';
import BulkActions from 'components/ContactList/BulkActions/BulkActions';
import BulkAction from 'components/ContactList/BulkActions/BulkAction';
import moment from 'moment';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { billingAccounts, modals } from '../../ducks/index';
import duckify, { singleDuck } from '../../utils/duckify';

const getMonthStatement = (billingAccountId, year, month) => {
  const url = `/billing_accounts/${billingAccountId}/statement?year=${year}&month=${month}`;
  return (
    modals.actions.show(
      'Downloader', {
        async: false,
        url,
        autoClose: true,
        httpMethod: 'GET'
      }
    ));
};

const MonthlyStatementGenerator = connect()(({ billingAccountId, billingAccount, soloButton, dispatch }) => {
  const currentYear = moment().year();
  const currentMonth = moment().month();
  const billingYears = billingAccount.available_statement_years || []
  const years = [currentYear, currentYear - 1, currentYear - 2];
  if (currentMonth === 11) { years.unshift(currentYear + 1); }
  if (billingYears.length !== 0){
    years.splice(0, years.length, ...billingYears)
  }
  const months = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];
  return (
    <DropdownMenuWrapper soloButton={soloButton}>
      <BulkAction iconName='file-text-o' title='Monthly Statements' soloButton={soloButton}>
        {years.map((year) => (
          <BulkAction title={year.toString()}>
            {months.map((month, index) => (
              <BulkAction
                title={month}
                onClick={() => dispatch(getMonthStatement(billingAccountId, year, index + 1))}
              />
            ))}
          </BulkAction>
        ))}
      </BulkAction>
    </DropdownMenuWrapper>
  );
});

const DropdownMenuWrapper = ({ soloButton, children }) => (soloButton ? <div className='dropdown'>{children}</div>
  : <BulkActions>{children}</BulkActions>);

DropdownMenuWrapper.propTypes = {
  /** Whether this should be wrapped by BulkActions */
  soloButton: PropTypes.bool,

  /** Content of the wrapper */
  children: PropTypes.node.isRequired
};
DropdownMenuWrapper.defaultProps = {
  soloButton: false
};

const mapDucksToProps = ({ billingAccountId }) => ({
  billingAccount: singleDuck(billingAccounts, billingAccountId)
})

export default duckify(mapDucksToProps)( MonthlyStatementGenerator)
